import { Component, Input, OnInit } from '@angular/core';
import { AccountingPeriodBlock } from '../../../models/AccountingPeriodBlock.model';

@Component({
    selector: 'app-accounting-block',
    templateUrl: './accounting-block.component.html',
    styleUrls: ['./accounting-block.component.scss']
})

export class AccountingBlockComponent implements OnInit {

    @Input() accountingBlock: AccountingPeriodBlock

    constructor(
    ) { }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/accounting-block/accounting-block.component.ts